import { useMemo } from 'react';
import useStepFlowStore from '@/stores/stepFlow/stepFlowStore';
import {
  CHATBOT_ONBOARDING_STEPS,
  CHATBOT_ONBOARDING_WORKFLOW_KEY
} from '@/stores/stepFlow/chatbotOnboardingSteps';
import { computeStepUiState } from '@/helpers/stepFlow/computeStepUiState';

/**
 * Read-only onboarding step display (title, description, progress) for the current chatbot.
 * Safe to use outside useStepFlow — does not initialize or fetch flows.
 */
export default function useChatbotOnboardingStepUiState(kbId) {
  const flowKey = kbId ? `${CHATBOT_ONBOARDING_WORKFLOW_KEY}:${kbId}` : null;
  const flow = useStepFlowStore((state) => (flowKey ? state.flows[flowKey] : null));
  const ask3QuestionsCount = useStepFlowStore((state) => state.ask3QuestionsCount);

  return useMemo(
    () => computeStepUiState({ flow, stepsConfig: CHATBOT_ONBOARDING_STEPS, ask3QuestionsCount }),
    [flow, ask3QuestionsCount]
  );
}
